<template>
  <div>
    <table class="table" :class="tableClass">
      <thead>
        <slot name="columns">
          <th
            v-for="(column, key) in columns"
            :class="'text-' + column.align"
            :key="key"
            @click="sortBy(column)"
          >
            <div class="table-header">
              <div class="table-header-title">
                {{ column.titleKey | setText(column.title) }}
              </div>
              <div v-if="column.sortBy" class="table-header-sort">
                <span
                  :style="{
                    opacity:
                      sort.orderType === 'ACS' && sort.orderBy === column.sortBy
                        ? 1
                        : 0.4,
                  }"
                  class="ti-arrow-circle-up"
                ></span>
                <span
                  :style="{
                    opacity:
                      sort.orderType === 'DESC' &&
                      sort.orderBy === column.sortBy
                        ? 1
                        : 0.4,
                  }"
                  class="ti-arrow-circle-down"
                ></span>
              </div>
            </div>
          </th>
        </slot>
      </thead>

      <tbody
        :move="onMove"
        v-if="dataArray.length"
        :tag="'tbody'"
        @change="positionItem"
      >
        <tr width="auto" v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <template v-for="(column, index) in columns">
              <td
                class="control-item full"
                v-if="
                  (column.detail === true ||
                    column.remove === true ||
                    column.log === true ||
                    column.info === true ||
                    column.input === true) &&
                  item.id
                "
                :key="`head-${index}`"
              >
                <button
                  v-if="column.detail === true"
                  @click="openObject(item, card)"
                  class="ml-2 btn btn-table"
                >
                  <span class="ti-arrow-right"></span>
                </button>

                <button
                  v-if="column.info === true"
                  @click="openObject(item, card)"
                  class="ml-2 btn btn-table btn-primary"
                >
                  <span class="ti-info"></span>
                </button>

                <button
                  v-if="column.log === true && $store.state.user['is_root']"
                  @click="openObject(item, card + '_log')"
                  class="ml-2 btn btn-table btn-primary"
                >
                  <span class="ti-info"></span>
                </button>

                <button
                  v-if="column.remove === true"
                  @click="removeItem(item.id)"
                  class="btn ml-2 btn-table btn-danger"
                >
                  <span class="ti-trash"></span>
                </button>
              </td>
              <td
                v-else
                :align="column.align ? column.align : 'left'"
                :key="index"
                :class="`${
                  column.full === true ||
                  column.price === true ||
                  column.key === 'created_at'
                    ? 'full'
                    : ''
                } ${column.minWidth === true ? 'minWidth' : ''}`"
              >
                <div v-if="column.media === true">
                  <div v-for="medium in item.media" :key="medium.id">
                    <a target="_blank" :href="medium.original_url" class="link">
                      <b>{{ medium.collection_name }}:</b> {{ medium.name }} <span class="ti-upload ml-2"></span
                        >
                    </a>
                  </div>
                </div>
                <div v-if="column.inputSet === true">
                  <input
                    class="input"
                    v-model="item[column.key]"
                    @input="setUpdate(item, column.key)"
                  />
                </div>
                <span v-else-if="column.small"> 22 </span>
                <span
                  v-else-if="column.color === true"
                  class="badge"
                  :style="{
                    backgroundColor: item[column.key]
                      ? item[column.key]
                      : '#111',
                    color: '#fff',
                  }"
                  >{{ item[column.key] }}</span
                >
                <div v-else-if="column.link === true">
                  <a
                    v-if="item[column.key]"
                    class="link"
                    :href="item[column.key]"
                    target="_blank"
                    :title="item[column.key]"
                  >
                    <span>Скачать</span></a
                  >
                  <span v-else>-</span>
                </div>
                <div v-else-if="column.input">
                  <span>
                    <input
                      v-model="item[column.key]"
                      :type="column.input"
                      class="form-control"
                    />
                  </span>
                </div>
                <div v-else-if="column.checkbox === true">
                  <checkbox
                    v-if="!simple"
                    v-model="val"
                    :value="item.id"
                    color="#2c75ff"
                  >
                    <span v-html="itemValue(item, column)"></span>
                  </checkbox>
                  <div v-if="simple" class="radiobox">
                    <input
                      v-if="simple"
                      :id="card + 'item-' + item.id"
                      :value="item.id"
                      :name="card ? card : 'selector'"
                      v-model="val"
                      type="radio"
                    />
                    <label :for="card + 'item-' + item.id">
                      <span v-html="itemValue(item, column)"></span>
                    </label>
                  </div>
                </div>

                <div v-else-if="column.dateFormat === true">
                  <span v-if="column.object && item[column.key][column.object]">
                    {{ item[column.key][column.object] | dateFormat }}
                  </span>

                  <span v-else> {{ item[column.key] | dateFormat }}</span>
                </div>
                <div v-else-if="column.dateTimeFormat === true">
                  <span v-if="column.object && item[column.key][column.object]">
                    {{ item[column.key][column.object] | dateTimeFormat }}
                  </span>
                  <span v-else> {{ item[column.key] | dateTimeFormat }}</span>
                </div>
                <div v-else-if="column.price === true">
                  <span v-if="column.object && item[column.key][column.object]">
                    {{ item[column.key][column.object] | spaceBetweenNumber }}
                  </span>
                  <span v-else>
                    {{ item[column.key] | spaceBetweenNumber }}</span
                  >
                </div>
                <div v-else-if="column.image === true">
                  <img
                    v-if="itemValue(item, column)"
                    :src="itemValue(item, column)"
                    :alt="`img`"
                    class="img"
                  />
                </div>
                <div v-else-if="column.timer === true">
                  <timer :item="item" />
                </div>
                <div
                  v-else-if="
                    column.key === 'status' &&
                    item[column.key] &&
                    item[column.key]['code'] &&
                    item[column.key]['name']
                  "
                >
                  <span
                    :class="` badge  ${
                      item[column.key] &&
                      item[column.key]['code'] &&
                      item[column.key]['code'] === 'success'
                        ? 'badge-success'
                        : 'badge-danger'
                    } `"
                    >{{ item[column.key]["name"] }}</span
                  >
                </div>
                <div
                  v-else-if="column.compare === true || column.percent === true"
                >
                  <b> {{ item[column.key] | spaceBetweenNumber }} </b>

                  <span
                    v-if="column.percent"
                    :class="`ml-2 badge badge-${
                      item['percent_' + column.key] > 0 ? 'warning' : 'warning'
                    }`"
                  >
                    {{ item["percent_" + column.key] | spaceBetweenNumber }} %
                  </span>
                  <span
                    v-if="column.compare"
                    :class="`ml-2 badge badge-${
                      item['compare_' + column.key] > 0 ? 'success' : 'danger'
                    }`"
                  >
                    {{ item["compare_" + column.key] > 0 ? "+" : "" }}
                    {{ item["compare_" + column.key] | spaceBetweenNumber }} %
                  </span>
                </div>
                <div v-else>
                  <span
                    v-if="index == 0 && drag === true"
                    class="ti-exchange-vertical text-info"
                  ></span>
                  <span
                    v-if="
                      !column.key_type &&
                      column.object &&
                      column.key &&
                      item[column.key] &&
                      column['disableLink'] !== true
                    "
                    @click="
                      openObject(
                        item[column.key],
                        column.keyAs ? column.keyAs : column.key,
                        'item_'
                      )
                    "
                    class="badge badge-info"
                  >
                    <div v-html="itemValue(item, column)"></div>
                  </span>

                  <span v-else v-html="itemValue(item, column)"> </span>
                </div>
              </td>
            </template>
          </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import draggable from "vuedraggable";
import timer from "../components/Timer";
import { errorNotify } from "@/plugins/functions";
export default {
  components: {
    timer,
    draggable,
  },

  data() {
    return {
      timerInput: {},
      noImage: require("@/assets/img/no-photo-available.png"),
      // val: [],
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
    };
  },
  name: "paper-table",
  props: {
    drag: {
      default: false,
    },
    additionalId: {
      default: null,
    },
    card: {
      default: null,
    },
    current_page: {
      default: 1,
    },
    columns: Array,
    data: Array,
    type: {
      type: String,
      default: "striped",
    },
    itemLink: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    simple: {
      default: false,
    },
    subTitle: {
      type: String,
      default: "",
    },
    removeItem: {
      default: function () {},
    },
    items: {
      default: function () {},
    },
    value: {
      default: function () {
        return [];
      },
    },
    dataObject: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    ...mapState(["languages"]),
    tableClass() {
      return `table-${this.type}`;
    },
    val: {
      get() {
        let val;
        if (!this.simple) {
          val = [];
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].id) {
              this.dataObject[this.value[i].id]["input_data"] =
                this.value[i].input_data;
              val.push(this.value[i].id);
            }
          }
        } else {
          val = this.value;
        }

        //console.log('object: ',this.dataObject);
        return val;
      },
      set(val) {
        let result;
        if (!this.simple) {
          result = [];
          for (let i = 0; i < val.length; i++) {
            if (this.dataObject[val[i]]) {
              result.push(this.dataObject[val[i]]);
            }
          }
        } else {
          result = [this.dataObject[val]];
        }
        //console.log(this.value);
        this.$emit("input", result);
      },
    },
    dataArray: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("changeData", val);
      },
    },
  },
  methods: {
    sortBy(column) {
      if (column.sortBy) {
        this.sort.orderType =
          this.sort.orderType === "ACS" && this.sort.orderBy === column.sortBy
            ? "DESC"
            : "ACS";
        this.sort.orderBy = column.sortBy;
        this.$emit("sortby", this.sort);
      }
    },
    openObject(item, card, prefix = "") {
      // console.log(item);
      // if (card === "model" && item["model_type"]) {
      //   alert(2);
      //   card = `item_${item["model_type"]}`;
      // }

      // console.log(card);

      const element = `${prefix}${card}`;

      let link = item.id;
      let push = true;
      if (this.additionalId) {
        link += "-" + this.additionalId;
      }

      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
        push = false;
      }
      query[element] = link;
      setTimeout(() => {
        push
          ? this.$router.replace({ query: query }, null)
          : this.$router.replace({ query: query }, null);
      }, 20);
    },

    // change(e) {},
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },

    itemValue(item, column) {
      let key = column.key;

      let titleObject = item[key];

      if (column.image === true) {
        return item[key] ? item[key] : this.noImage;
      }

      if (typeof item[key] === "object" && item[key] !== null) {
        if (Array.isArray(titleObject) && titleObject.length) {
          return titleObject
            .map((elem) => {
              if (column.object) {
                if (column.key === "translations") {
                  if (
                    !this.languages[elem["locale"]] ||
                    !elem[column.object] ||
                    elem[column.object] === "null"
                  ) {
                    return null;
                  }
                  return (
                    (column.key === "translations"
                      ? ' <span class="badge badge-info mr-1">' +
                        elem["locale"] +
                        ": </span>"
                      : "") +
                    elem[column.object] +
                    "<br/>"
                  );
                } else if (column.key === "imeis") {
                  return `<div class=" ${column["disableLink"] ? "" : ""} mr-1">
                   ${elem[column.object]}  ${
                    elem["status"]
                      ? `<span class="badge badge-${
                          elem["status"] == "block" ? "danger" : "success"
                        } mr-1">  ${elem["status"]} </span>`
                      : ""
                  }
                  </div>`;
                } else if (column.key === "discounts") {
                  return `<div class=" ${column["disableLink"] ? "" : ""} mr-1">
                  <span class="badge  badge-danger">  ${
                    elem[column.object] ? elem[column.object] : "Услуга TRADEIN"
                  } </span>
                  </div>`;
                } else {
                  return `<span class=" ${
                    column["disableLink"] ? "badge badge-info" : ""
                  } mr-1">
                   ${elem[column.object]}
                  </span>`;
                }
              }
            })
            .filter((el) => {
              return el;
            })
            .join(``);
        } else if (column.object && titleObject[column.object]) {
          if (column.recurcy) {
            return this.recurcyData(titleObject, column);
          }
          return `<span>${titleObject[column.object]}</span>`;
        } else {
          return "-";
        }
      } else if (key === "is_paid") {
        return item[key]
          ? this.$store.state.text["paid_now"]
          : this.$store.state.text["no_paid_now"];
      } else if (typeof item[key] === "boolean") {
        return item[key] ? "Да" : "Нет";
      }

      // if (item[key.toLowerCase()] || item[key.toLowerCase()] === 0) {
      return item[key];
      // }

      // if (column.object && column.objectDefault) {
      //   return column.objectDefault;
      // }

      return "-";
    },

    recurcyData(object, column) {
      let data = this.recurcyInit(object, column);
      if (object[column.recurcy]) {
        data += this.recurcyData(object[column.recurcy], column);
      }
      return data;
    },
    recurcyInit(object, column) {
      let datum = `<span class="badge badge-warning mr-1">${
        object[column.object]
      }</span>`;

      return datum;
    },
    setUpdate(item, column) {
      let data = {};

      if (this.timerInput[item["id"]]) {
        clearTimeout(this.timerInput[item["id"]]);
        this.timerInput[item["id"]] = null;
      }
      this.timerInput[item["id"]] = setTimeout(() => {
        let url = `${this.itemLink}/${item["id"]}`;
        data[column] = item[column];
        // this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            // this.$loading(false);
          });
      }, 800);
    },
    positionItem(val) {
      if (val && val.moved) {
        let moved = val.moved;
        let elementId = moved.element.id;
        let oldIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.oldIndex +
          1;
        let newIndex =
          (this.items.current_page - 1) * this.items.per_page +
          moved.newIndex +
          1;
        let url = `lessonplans/${elementId}?change_position=1`;
        let data = {
          newIndex,
          oldIndex,
        };
        this.$loading(true);
        this.$http
          .put(url, data)
          .then((response) => {})
          .catch((error) => {
            errorNotify(error, this.$notify);
          })
          .finally((res) => {
            this.$loading(false);
          });
      }
    },
    onMove() {
      return this.drag;
    },
  },
};
</script>
